<template>
  <div class="report" style="width: 70%; margin: auto">
    <div style="position: relative; margin-bottom: 60px">
      <h2 class="tab-title">
        {{ $t("List of signature transactions") }}
      </h2>
      <md-menu style="float: right" :md-active.sync="openSortMenu">
        <span
          @click="toggleOrder()"
          style="cursor: pointer; top: 8px; position: relative"
          >Sort by
          <md-icon v-if="!ascOrder">expand_circle_down</md-icon>
          <md-icon v-if="ascOrder" style="transform: rotate(180deg)"
            >expand_circle_down</md-icon
          >
        </span>
        <md-button class="md-icon-button" md-menu-trigger>
          <md-icon>sort</md-icon>
        </md-button>

        <md-menu-content>
          <md-menu-item>
            <md-icon>drive_file_rename_outline</md-icon>

            <span>Name</span>
          </md-menu-item>

          <md-menu-item>
            <md-icon>today</md-icon>
            <span>Date</span>
          </md-menu-item>

          <md-menu-item>
            <md-icon>pending</md-icon>
            <span>Progress</span>
          </md-menu-item>
        </md-menu-content>
      </md-menu>
    </div>

    <md-list class="md-triple-line">
        <md-subheader v-if="!ascOrder">Done</md-subheader>
      <md-list-item v-if="!ascOrder" style="border-bottom: 1px solid lightgray">
        <div
          style="width: 100%; cursor: pointer"
          @click="$router.push('trail')"
        >
          <div style="width: 100%; display: flex">
            <div style="margin-right: 10px">
              <md-icon>create</md-icon>
            </div>

            <div class="md-list-item-text">
              <span>Authorization</span>
              <span style="text-align: justify">02.05.2021</span>
              <span style="text-align: justify">ID: 00350</span>
            </div>

            <div>
              <md-icon style="color: limegreen">verified</md-icon>
            </div>
          </div>
        </div>
      </md-list-item>
       <!-- <md-divider></md-divider> -->
      <md-subheader>In progess</md-subheader>

            <md-list-item v-if="!ascOrder" style="border-bottom: 1px solid lightgray">
        <div
          style="width: 100%; cursor: pointer"
          @click="$router.push('trail')"
        >
          <div style="width: 100%; display: flex">
            <div style="margin-right: 10px">
              <md-icon>create</md-icon>
            </div>

            <div class="md-list-item-text">
              <span>Cartago Contract</span>
              <span style="text-align: justify">02.05.2021</span>
              <span style="text-align: justify">ID: 00348</span>
            </div>
            <div style="display: flex">
              <div>
                <md-progress-bar
                  md-mode="determinate"
                  :md-value="75"
                  style="width: 170px; top: 9px; right: 13px"
                ></md-progress-bar>
              </div>

              <md-icon>verified</md-icon>
            </div>
          </div>
        </div>
      </md-list-item>
      <md-list-item v-if="!ascOrder" style="border-bottom: 1px solid lightgray">
        <div
          style="width: 100%; cursor: pointer"
          @click="$router.push('trail')"
        >
          <div style="width: 100%; display: flex">
            <div style="margin-right: 10px">
              <md-icon>create</md-icon>
            </div>

            <div class="md-list-item-text">
              <span>Document sign</span>
              <span style="text-align: justify">02.05.2021</span>
              <span style="text-align: justify">ID: 00349</span>
            </div>

            <div style="display: flex">
              <div>
                <md-progress-bar
                  md-mode="determinate"
                  :md-value="50"
                  style="width: 170px; top: 9px; right: 13px"
                ></md-progress-bar>
              </div>

              <md-icon>verified</md-icon>
            </div>
          </div>
        </div>
      </md-list-item>

            <md-list-item v-if="!ascOrder" style="border-bottom: 1px solid lightgray">
        <div
          style="width: 100%; cursor: pointer"
          @click="$router.push('trail')"
        >
          <div style="width: 100%; display: flex">
            <div style="margin-right: 10px">
              <md-icon>create</md-icon>
            </div>

            <div class="md-list-item-text">
              <span>Document approvement</span>
              <span style="text-align: justify">02.05.2021</span>
              <span style="text-align: justify">ID: 00380</span>
            </div>

            <div style="display: flex">
              <div>
                <md-progress-bar
                  md-mode="determinate"
                  :md-value="25"
                  style="width: 170px; top: 9px; right: 13px"
                ></md-progress-bar>
              </div>

              <md-icon>verified</md-icon>
            </div>
          </div>
        </div>
      </md-list-item>
    
         <md-list-item v-if="ascOrder" style="border-bottom: 1px solid lightgray">
        <div
          style="width: 100%; cursor: pointer"
          @click="$router.push('trail')"
        >
          <div style="width: 100%; display: flex">
            <div style="margin-right: 10px">
              <md-icon>create</md-icon>
            </div>

            <div class="md-list-item-text">
              <span>Document approvement</span>
              <span style="text-align: justify">02.05.2021</span>
              <span style="text-align: justify">ID: 00380</span>
            </div>

            <div style="display: flex">
              <div>
                <md-progress-bar
                  md-mode="determinate"
                  :md-value="25"
                  style="width: 170px; top: 9px; right: 13px"
                ></md-progress-bar>
              </div>

              <md-icon>verified</md-icon>
            </div>
          </div>
        </div>
      </md-list-item>
      <md-list-item v-if="ascOrder" style="border-bottom: 1px solid lightgray">
        <div
          style="width: 100%; cursor: pointer"
          @click="$router.push('trail')"
        >
          <div style="width: 100%; display: flex">
            <div style="margin-right: 10px">
              <md-icon>create</md-icon>
            </div>

            <div class="md-list-item-text">
              <span>Document sign</span>
              <span style="text-align: justify">02.05.2021</span>
              <span style="text-align: justify">ID: 00349</span>
            </div>

            <div style="display: flex">
              <div>
                <md-progress-bar
                  md-mode="determinate"
                  :md-value="50"
                  style="width: 170px; top: 9px; right: 13px"
                ></md-progress-bar>
              </div>

              <md-icon>verified</md-icon>
            </div>
          </div>
        </div>
      </md-list-item>

           <md-list-item v-if="ascOrder" style="border-bottom: 1px solid lightgray">
        <div
          style="width: 100%; cursor: pointer"
          @click="$router.push('trail')"
        >
          <div style="width: 100%; display: flex">
            <div style="margin-right: 10px">
              <md-icon>create</md-icon>
            </div>

            <div class="md-list-item-text">
              <span>Cartago Contract</span>
              <span style="text-align: justify">02.05.2021</span>
              <span style="text-align: justify">ID: 00348</span>
            </div>
            <div style="display: flex">
              <div>
                <md-progress-bar
                  md-mode="determinate"
                  :md-value="75"
                  style="width: 170px; top: 9px; right: 13px"
                ></md-progress-bar>
              </div>

              <md-icon>verified</md-icon>
            </div>
          </div>
        </div>
      </md-list-item>
      <md-divider></md-divider>

      <md-subheader v-if="ascOrder">Done</md-subheader>
      <md-list-item v-if="ascOrder" style="border-bottom: 1px solid lightgray">
        <div
          style="width: 100%; cursor: pointer"
          @click="$router.push('trail')"
        >
          <div style="width: 100%; display: flex">
            <div style="margin-right: 10px">
              <md-icon>create</md-icon>
            </div>

            <div class="md-list-item-text">
              <span>Authorization</span>
              <span style="text-align: justify">02.05.2021</span>
              <span style="text-align: justify">ID: 00350</span>
            </div>

            <div>
              <md-icon style="color: limegreen">verified</md-icon>
            </div>
          </div>
        </div>
      </md-list-item>
    </md-list>
  </div>
</template>

<script>
export default {
  name: "Report",
  components: {},
  data() {
    return {
      openSortMenu: false,
      ascOrder: false,
    };
  },
  created(){
    this.$material.locale.dateFormat =localStorage.getItem("generalConfiguration") ? JSON.parse(localStorage.getItem("generalConfiguration"))["dateFormat"] : "dd.MM.yyyy";
  },
  mounted(){
    this.$material.locale.dateFormat =localStorage.getItem("generalConfiguration") ? JSON.parse(localStorage.getItem("generalConfiguration"))["dateFormat"] : "dd.MM.yyyy";
  },
  methods: {
    showSortMenu() {
      this.openSortMenu = true;
    },
    toggleOrder() {
      this.ascOrder = !this.ascOrder;
    },
  },
};
</script>
<style lang="scss">
.md-list-item-content {
  justify-content: unset;
}
.t-head {
  display: flex;
}
.t-title-group {
  display: flex;
  margin-left: 25px;
}
.t-number {
  width: 24px;
  height: 24px;
  border-radius: 24px;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  background: #e94e1b;
  color: white;
}

.t-body-wrapper {
  padding-left: 50px;
  margin-left: 12.5px;
  border-left: 1px solid lightgray;
  min-height: 20px;
  max-height: 0;

  overflow: hidden;
  padding-top: 1px;
  transition: all 1s ease;
}

.t-body-wrapper.expand {
  max-height: 200px !important;
}

.t-title-info {
  margin-left: 5px;
}

.t-title-type {
  font-weight: bold;
  color: #737373;
  font-size: 16px;
}

.t-title-email {
  color: #969696;
  font-size: 12px;
}

.t-record {
  margin-top: 40px;
  cursor: pointer;
}
.t-body-content i {
  font-size: 1.2em !important;
}
.t-body-content {
  margin-bottom: 15px;
}

.t-record:last-child .t-body-wrapper {
  border: none;
}
.t-record-group {
  // width: 70%;
  // margin:auto;
}
</style>